function keyMirrorPlus(obj, prefix) {
  var ret = {};
  var key;

  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error("keyMirror(...): Argument must be an object.");
  }
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    if (obj[key] instanceof Object) {
      ret[key] = keyMirrorPlus(obj[key], key + ".");
    } else {
      ret[key] = prefix + key;
    }
  }
  return ret;
}

export default keyMirrorPlus(
  {
    USER_AUTHENTICATED: null,
    USER_AUTHENTICATION_FAILED: null,
    PROFILE_LOADED: null,
    USER_LOGGED_OUT: null,
    GOOGLE_LOGOUT: null,
    RECIEVE_RAW_JOBS: null,
    IMPORTER_TABLE_INFORMATION_UPDATED: null,
    FILE_TO_IMPORT_SELECTED: null,
    UPLOAD_STARTED: null,
    UPLOAD_PROGRESSED: null,
    FILE_UPLOADED: null,
    SOURCE_SELECTED: null,
    COPY_OPTION_SELECTED: null,
    COPY_OPTION_DESELECTED: null,
    DISTRIBUTION_KEY_UPDATE_REQUESTED: null,
    SORT_KEY_UPDATE_REQUESTED: null,
    DELIMITER_SELECTED: null,
    USER_ADDED: null,
    USER_REMOVED: null,
    IMPORTER_RESET_REQUESTED: null,
    JOB_SUBMIT_REQUESTED: null,
    JOB_SUBMITTED: null,
    LOGS_REQUESTED: null,
    LOGS_NO_LONGER_NEEDED: null,
    RECEIVE_JOB_LOGS: null,
    WORKBOOKS_RECEIVED: null,
    RECEIVE_RAW_SYNCS: null,
    EULA_SIGNATURE_ACKNOWLEDGED: null,

    CrossChannel: {
      SCENARIOS_RECEIVED: null,
      SOURCE_TABLES_RECEIVED: null,
      UPDATE_REQUESTED: null,
      ADDVALUE_REQUESTED: null,
      REMOVEVALUE_REQUESTED: null,
      UPDATE_MAP: null,
      UPDATE_MODE: null,
      RESET_REQUESTED: null,
      SCENARIO_CLONED: null,
      SCENARIO_SAVED: null,
      SAVED_SCENARIO_RUN: null,
      RUNS_RECEIVED: null,
      SCENARIO_DESTROYED: null,
      RUN_SUBMITTED: null,
    },

    Daemons: {
      DAEMONS_RECEIVED: null,
    },

    SavedJobs: {
      RECEIVE_SAVED_JOBS: null,
      SAVED_JOB_LAUNCHED: null,
      JOB_CREATED: null,
      JOB_RECEIVED: null,
      JOB_UPDATED: null,
      JOB_DELETED: null,
    },

    NewJob: {
      NEW_JOB_REQUESTED: null,
    },

    Importer: {
      UPDATE_REQUESTED: null,
      ADDVALUE_REQUESTED: null,
      REMOVEVALUE_REQUESTED: null,
    },

    Exporter: {
      UPDATE_REQUESTED: null,
      RESET_REQUESTED: null,
    },

    Matching: {
      UPDATE_REQUESTED: null,
      RESET_REQUESTED: null,
    },

    Googledocs: {
      RECEIVED_REFRESH_TOKEN: null,
    },

    Admin: {
      USER_DATA_REQUESTED: null,
      CURRENT_USER_LOADED: null,
      ORGANIZATION_SET: null,
      ORGANIZATION_LOADED: null,
      USER_DATA_LOADED: null,
      MEMBERSHIP_CREATED: null,
      MEMBERSHIP_UPDATED: null,
      MEMBERSHIP_DELETED: null,
      LOGIN_STYLING_LOADED: null,
      LOGIN_STYLING_NOT_FOUND: null,
      LOGIN_STYLING_REQUESTED: null,
      USER_LIST_LOADED: null,
    },

    Credentials: {
      RESOURCES_RECEIVED: null,
      RESOURCE_CREATED: null,
      RESOURCE_RECEIVED: null,
      RESOURCE_UPDATED: null,
      RESOURCE_DELETED: null,
      SECRETS_RECEIVED: null,
      SECRET_CREATED: null,
      SECRET_RESOURCE: null,
      SECRET_UPDATED: null,
      SECRET_DELETED: null,
      NEW_SECRET_ADDED: null,
      NEW_SECRET_REMOVED: null,
      NEW_RESOURCE_ADDED: null,
      NEW_RESOURCE_REMOVED: null,
    },

    Content: {
      CONTENT_RECEIVED: null,
      INDEX_RECEIVED: null,
    },
  },
  ""
);
